import React, { useState, useEffect, useRef } from 'react'
import { IonButton, IonContent, IonHeader, IonModal, IonPage, IonText, IonTitle, IonToolbar, IonicSlides, IonGrid, IonRow, IonIcon, IonItem, IonList, IonInput, IonLabel, IonTextarea, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonButtons, IonListHeader, IonChip, IonCol, IonSelect, IonSelectOption, IonAvatar, IonToggle, IonNote, IonAlert, useIonViewWillLeave, IonImg, useIonViewWillEnter, isPlatform } from '@ionic/react'
import { Navigation, Pagination, Scrollbar,  } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';

import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import './mySwiper.scss'
import { walk as walkIcon, arrowBack, arrowForward, chatbox, closeCircle, eye, location, lockClosed, mic, pencil, people, person, time, walkOutline, repeat, mapOutline, eyeOutline, caretDown, lockOpen, informationCircle, search } from 'ionicons/icons';
import Api from "../../services/Api"
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { WalkI } from '../../interfaces/Walk';
import { goToPage, goToPageWithState } from '../../helpers/app_actions';
import GoogleMapNew from './GoogleMapNew';
import { CONFIG } from '../../constants'
import CreateCalendarPicker from './CreateCalendarPicker';
import CreateWalkType from './CreateWalkType';
import {walkTypes} from './walkTypes'
import CreateNetworkPicker from './CreateNetworkPicker';
import { RootState } from '../../redux/reducers';
import CreatePersonInvite from './CreatePersonInvite';
import CreateCategory from './CreateCategory';
import CreateRepeat from './CreateRepeat';
import { SafetyPadding } from '../../components/SafetyPadding';
import history from '../../helpers/history';
import CreateGroup from './CreateGroup';
import CreateDay from './CreateDay';
import CreateTime from './CreateTime';
import { openAlert } from '../../redux/actions/alertActions';
import { sendMessageWalk } from '../../helpers/chat_actions';
import FirebaseProvider from '../../services/FirebaseAnalytics'
import UpgradeAlert from './Components/UpgradeAlert';

export interface CreateWalkInterface {
  walkId: number
  name: string,
  place_name: string | null | undefined,
  description: string | null | undefined,
  lat: number,
  lng: number,
  zoom: number,
  start: string,
  startFormat: any,
  length_minutes: number,
  teamId: Number | null,
  address: string,
  category: string,
  invited_persons: Array<any> ,
  invite_only: boolean,
  profile_only: boolean,
  max_bookings: number,
  hasCoordinates: boolean,
  hasTalk: boolean
  recurring: Array<any> 
}

interface ParamTypes {
  walkId: string
}

export const CreatePage = () => {
  const firebaseProvider = FirebaseProvider.getInstance()
  const api = Api.getInstance()
  const dispatch = useDispatch()
  const { walkId } = useParams<ParamTypes>()

  const team = useSelector((state: RootState) => state.logIn.user.teams)
  const hasPro = useSelector((state: RootState) => state.logIn.user.WTTeams)
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass>({} as SwiperClass) ;
  const [openSlides, setOpenSlides] = useState(false)
  const [activeSlide, setActiveSlide] = useState(0)
  const [activeFlow, setActiveFlow] = useState<Array<number>>([0,3]) // this decides which slides will be shown
  const [error, setError] = useState({
    status: false,
    message: 'Check your input',
    title: false,
    map: false,
    start: false,
    type: false
  })
  const [walk, setWalk] = useState<CreateWalkInterface>({
    walkId: 0,
    name: 'Walk',
    place_name: '',
    description: '',
    lat: 59.3,
    lng: 17.93,
    zoom: 15,
    start: '',
    startFormat: '',
    length_minutes: 60,
    teamId: null,
    address: '',
    category: '',
    invited_persons: [] ,
    invite_only: false, 
    profile_only: false,
    max_bookings: 1,
    hasCoordinates: true,
    hasTalk: false,
    recurring: []              
  })
  const [pageInfo, setPageInfo] = useState({
    header: api.tr('Creating_walk_top'),
    button: api.tr('ButtonCreateTop')
  })
  const [create,setCreate] = useState(true)
  const [description, setDescription] = useState(false)
  const [repeatOption, setRepeatOption] = useState('')
  const [proModal, setProModal] = useState(false)
  const [errorAlert, setErrorAlert] = useState(false)
  const [closingAlert, setClosingAlert] = useState(false)
  const [previousSlides, setPreviousSlides] = useState<Array<number>>([])

  const usePrevious = (value: any) => {
    const ref: any = useRef();
    useEffect(() => {
      ref.current = value; //assign the value of ref to the argument
    },[value]); //this code will run when the value of 'value' changes
    return ref.current; //in the end, return the current ref value.
  }

 useIonViewWillEnter(() => {
  firebaseProvider.trackView('NewCreate_page')
  viewDecider(window.location.pathname)
 })

  const viewDecider = (urlString: string) => {
    if(urlString === '/walk/create' ) {
      openCreate()
    } 

    if(urlString.includes('/walk/edit')) {
      openEdit(urlString)
    }

    if (urlString.includes('/walk/copy')) {
      openCopy()
    }

    if(urlString.includes('/walk/time')) {
      openTime()
    }
  }

  const openCreate = () => {
    setActiveFlow([10,3,1,0])
    setDefaultWalk()
    setCreate(true) // sets map in create
  }

  const openEdit = (urlString: string) => {
    setActiveFlow([0])
    setPageInfo({
      ...pageInfo, 
      header: api.tr('edit_walk'), 
      button: api.tr('save')
    })
    setOpenSlides(true)
    setCreate(false) //sets map in edit mode

    if(walkId !== '0' && walkId !== undefined) {
      fetchWalk(urlString)
    }
  }

  const openCopy = () => {
    getHistoryWalk()
    setCreate(false)
    setPageInfo({...pageInfo, header: 'Kopiera promenad', button: 'Spara'})
  }

  const openTime = () => {
    getHistoryWalk()
    setCreate(true)
    setPageInfo({...pageInfo, header: 'Skapa från kalender', button: 'Spara'})
  }

  const getHistoryWalk = () => {
    const historyWalk = history.location.state as WalkI
    let invitedPerson: Array<number> = []
    if(historyWalk.availableTo.length > 0) {
      invitedPerson = [historyWalk.availableTo[0].id]
    }
    setWalk({
      ...walk,
      name: historyWalk.name ? historyWalk.name : '',
      place_name: historyWalk.placeName ? historyWalk.placeName : '',
      description: historyWalk.description ? historyWalk.description : '',
      teamId: historyWalk.teamId ? historyWalk.teamId : null,
      lat: historyWalk.lat,
      lng: historyWalk.lng,
      address: historyWalk.address ? historyWalk.address : '',
      zoom: historyWalk.zoom,
      start: historyWalk.start,
      startFormat: historyWalk.start,
      max_bookings: historyWalk.maxBookings ? historyWalk.maxBookings : 1,
      invited_persons: invitedPerson,
      invite_only: historyWalk.inviteOnly ? historyWalk.inviteOnly : false,
      profile_only: historyWalk.profileOnly ? historyWalk.profileOnly : false,
      length_minutes: historyWalk.lengthMinutes ? historyWalk.lengthMinutes : 60,
      hasCoordinates: historyWalk.hasCoordinates ? historyWalk.hasCoordinates : false,
      hasTalk: historyWalk.hasTalk ? historyWalk.hasTalk : true,
      category: historyWalk.category ? historyWalk.category : '',
      recurring: historyWalk.recurring ? historyWalk.recurring : []
    })
    setOpenSlides(true)
    setActiveFlow([0])
  }

  useIonViewWillLeave(() => {
    setDefaultWalk()
    setCreate(true)
    setDescription(false)
    setRepeatOption('')
  })



  const prevFlow: Array<number> = usePrevious(activeFlow)
  const prevWalk = usePrevious(walk)

  useEffect(() => {
    setPreviousSlides(prevFlow)
  } , [activeFlow])

  const slidePrevious = () => {
    swiperInstance.allowSlidePrev = true
    swiperInstance.slidePrev()
  }
  
  const slideNext = () => {
    if(swiperInstance.allowSlideNext) {
      if(swiperInstance.isEnd) {
        openSlide(0)
      } else {
        swiperInstance.slideNext()
      }
    } else {
      if(swiperInstance.isEnd) {
        setActiveFlow([0])
      }
      setError({ ...error,
        status: true, 
      })
    }
    errorCheck()
  }

  const checkIfMapSlide = (id: number, type: string) => {
    if(id === 3){
      //handles when to show the map slide 
      if(type === 'hasCoord' || type === 'hasBoth') {
        slideNext()
      } else {
        if(swiperInstance.isEnd) {
          setActiveFlow([0])
        } else {
          swiperInstance.slideTo(swiperInstance.activeIndex + 2)
          errorCheck()
        }
      }
    } else {
      slideNext()
    }
  }

  const setType = (type: CreateWalkInterface) => {
    if(type.hasTalk && type.hasCoordinates) {
      return <IonChip color="primary" className="p-2 mr-2"><IonIcon icon={mic}/> Audio / <IonIcon icon={walkOutline}/> Plats</IonChip>
    } else if(type.hasTalk && !type.hasCoordinates) {
      return <IonChip color="primary" className="p-2 mr-2"><IonIcon icon={mic}/> Audio</IonChip>
    } else if(!type.hasTalk && type.hasCoordinates){
      return <IonChip color="primary" className="p-2 mr-2"><IonIcon icon={walkOutline}/> {api.tr('place')}</IonChip>
    } else {
      return <IonLabel slot="end" className="mr-2">Välj typ</IonLabel>
    }
  }

  const handleInvite = (person: number) => {
    if(person !== 0 && person !== null) {
      let value: Array<number> = []
      value.push(person)
      setWalk({ 
        ...walk, 
        invited_persons: [person], 
        // max_bookings: 1, 
        invite_only: true 
      })
    } else if(person === null) {
      setWalk({ ...walk, invited_persons: [] })
    }
  }

  const handleMultipleInvite = (persons: Array<number>) => {
    if(persons.length !== 0) {
      setWalk({ 
        ...walk, 
        invited_persons: persons, 
        max_bookings: persons.length, 
        invite_only: true 
      })
    } else if(persons === null) {
      setWalk({ 
        ...walk, 
        invited_persons: [] 
      })
    }
  }

  const handleLength = (minutes: number) => {
    setWalk({
      ...walk,
      length_minutes: minutes
    })
  }

  const handleStart = (time: string) => {
    setWalk({
      ...walk, 
      start: time,
      startFormat: time
    })
  }

  const handleLatLng = (lat: number, lng: number) => {
    enableSlideNext()
    enableSlidePrevious()
    setWalk({ 
      ...walk, 
      lat: lat, 
      lng: lng
    })
  }

  const handleTextInput = (e: any) => {
    setWalk({
      ...walk,
      [e.target.id]: e.target.value
    })
  }

  const handlePlaceInput = (text: string) => {
    enableSlideNext()
    enableSlidePrevious()
    setWalk({
      ...walk,
      place_name: text
    })
  }

  const setDefaultWalk = () => {
    setWalk({
      ...walk,
      walkId: 0,
      name: api.tr('walk'),
      place_name: '',
      description: '',
      lat: 59.3,
      lng: 17.93,
      zoom: 15,
      start: '',
      startFormat: '',
      length_minutes: 60,
      teamId: null,
      address: '',
      category: '',
      invited_persons: [] ,
      invite_only: false, 
      profile_only: false,
      max_bookings: 1,
      hasCoordinates: true,
      hasTalk: false,
      recurring: []
    })
  }

  useEffect(() => {
    setError({...error, start: false})
  }, [walk.recurring])

  useEffect(() => {
    if(swiperInstance.activeIndex === 1) {
      disableSlideNext()
      disableSlidePrev()
    }
  }, [])

  const saveMap = (lat: number, lng: number, zoom: number, placeName: string) => {
    setWalk({
      ...walk,
      lat: lat,
      lng: lng,
      zoom: zoom,
      place_name: placeName
    })

    getLocationName(lat, lng)
  }

  const getLocationName = (lat: Number, lng: Number) => {
    const areaRegex = /,\s\b(\w\D+)\b/i
    const digits = /\b[0-9]+/g

    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=sv&result_type=postal_town|administrative_area_level_1&key=${CONFIG.GOOGLE_KEY}`)
    .then(res => res.json())
    .then(data => {
        if(data.status === "OK"){
          let result = data.results.map((address: any) => {
            if(address.types.includes('postal_town')) {
              return address.formatted_address.replace(areaRegex, '').replace(digits, '')
            } else if (address.types.includes('administrative_area_level_1')) {
              return address.formatted_address.replace(areaRegex, '')
            }
            return null
          })

          if(result.length === 0) {
            setWalk({
              ...walk,
              address: api.tr('city_not_found')
            }) 
          } else if (result.length === 1) {
            setWalk({
              ...walk,
              address: result[0]
            })
          } else {
            setWalk({
              ...walk,
              address: `${result[0]}, ${result[1]}`
            })
          }
        } else {
          setWalk({
            ...walk,
            address: api.tr('city_not_found')
          })
        }
      }
    )
  }

  const cancelCreate = () => {
    //sets warning alert open
    setClosingAlert(true)
  }

  const cancelingCreate = () => {
    setDefaultWalk()
    setOpenSlides(false)
    goToPage('/walk/create')
  }

  const nextSlideButton = () => {
    return <IonGrid>
    <IonButton 
      class="m-2"
      expand="block"
      onClick={() => {
      // slideNext()
      saveWalk()
      }}>{api.tr('create_walk')}</IonButton>
    <IonButton color="danger" fill="clear" expand="block" onClick={() => { 
      cancelCreate()
    }}>{api.tr('cancel')}</IonButton>
  </IonGrid>
  }

  const getTeamName = () => {
    const teamName = team.filter((team: any) => walk.teamId === team.teamId)[0].teamName

    return teamName
  }

  // const getName = () => {
  //   const person = allAvailable.filter(person => person.friendId === walk.invited_persons[0])[0].name

  //   return person
  // }

  // const getImage = () => {
  //   const person = allAvailable.filter(person => {
  //     if(person.friendId === walk.invited_persons[0]) {
  //       // console.log(person.picture)
  //     }
  //   })

  //   return person
  // }

  const proButton = () => <IonChip className="p-2 mr-2" color={hasPro ? 'darkblue' : 'medium'} slot="start">
    { !hasPro ? <IonIcon color='medium' icon={lockClosed}/> : null }
    Pro
  </IonChip>

  const repetitionValue = () => {
    let value = ''

    if(repeatOption === 'none') {
      value = api.tr('Walking_DontRepeat')
    } else if(repeatOption === 'custom'){
      value = api.tr('frequency_choice1')
    } else if(repeatOption === 'daily'){
      value = api.tr('frequency_choice2')
    } else if(repeatOption === 'weekly'){
      value = api.tr('frequency_choice3')
    } else if(repeatOption === 'monthly'){
      value = api.tr('frequency_choice4')
    } else if(repeatOption === 'weekdays'){
      value = api.tr('frequency_choice5')
    }
    return value
  }

  const SlideOne = () => <IonContent><IonGrid>
  <IonCard className="m-2">
    <IonCardHeader color="darkblue" className="p-2">
      <IonItem color="darkblue" lines="none" className="margin_center" onClick={() => openSlide(4)}>
      <IonTitle color="light">Nätverk:</IonTitle>
      <IonChip color="light" className="m-2 p-2">
        <IonText className="text_right" placeholder="Enter place">{walk.teamId === null || walk.teamId === undefined ? api.tr('Part4_OpenNetwork') : getTeamName()}</IonText>
        <IonIcon icon={caretDown} color="light" size="small" className="mr-2"/>
      </IonChip>
    </IonItem>
    </IonCardHeader>
    <IonCardContent className="p-2">                         
      <IonCardTitle>
        <IonItem lines="none" color="light" className="mt-2">
          <h2 className="fullWidth">
            <IonInput
              className="fullWidth"
              value={walk.name} 
              placeholder="Enter walk title" 
              onIonChange={e => {
                setWalk({
                  ...walk, 
                  name: e.detail.value!
                })
              }}/>
          </h2>
          <IonIcon icon={pencil} size="small" className="mr-2" slot="end"/>
        </IonItem>
      </IonCardTitle>
    </IonCardContent>
  { error.title ? <IonItem lines={error.title ? 'none' : 'full'} color={(error.title || walk.name) && walk.name.length < 3 ? 'danger' : 'none'}>
    <IonNote slot="end" color="light">{api.tr('error_title_length')}</IonNote>
  </IonItem> : null }
  {walk.recurring && walk.recurring.length > 0 ? 
  <IonGrid className="flex flex-wrap">
    {walk.recurring.map((date: any, key: any) => <IonCol size="6" key={'map-' + date + key}><IonChip className="p-2 ml-2">{dayjs(date.start).format('DD MMMM HH:mm')}</IonChip></IonCol>)}
  </IonGrid> :
  <IonItem lines={error.start ? 'none' : 'full'} color={error.start ? 'danger' : 'none'} onClick={() => openSlide(10)}>
    <IonIcon icon={time} slot="start" size="small" className="mr-2" color={error.start === true? 'light' : 'darkblue'}/>
    <IonLabel>{api.tr('When_walk')}</IonLabel>
    <IonInput className="text_right" value={walk.start ? `${walk.start} - ${dayjs(walk.start).add(walk.length_minutes, 'minutes').locale(api.lang).format('HH:mm')}` : null} placeholder="Pick a time"/>
    <IonIcon icon={caretDown} slot="end" size="small" className="mr-2" color="dark"/>
  </IonItem>  }

  { error.start && walk.recurring.length === 0 ? <IonItem color="danger">
    <IonNote slot="end" color="light">{api.tr('Control_StartTime')}</IonNote>
  </IonItem> : null }
  <IonItem lines={error.type ? 'none' : 'full'} color={error.type ? 'danger' : 'none'} onClick={() => openSlide(3)}>
    <IonIcon color={error.type ? 'light' : 'darkblue'} icon={chatbox} slot="start" size="small" className="mr-2"/>
    <IonLabel>{api.tr('How_walk')}</IonLabel>
    {setType(walk)}
    <IonIcon icon={caretDown} slot="end" size="small" className="mr-2" color="dark"/>
  </IonItem>
  { error.type ? <IonItem color="danger">
    <IonNote slot="end" color="light">{api.tr('error_set_meeting')}</IonNote>
  </IonItem> : null }
  { walk.hasCoordinates ? 
  <IonItem lines={create ? 'none' : "full"} color={create ? 'danger' : 'none'} onClick={() => openSlide(1)}>
    <IonIcon icon={location} slot="start" size="small" className="mr-2" color={error.map || create ? 'light' : 'darkblue'}/>
    <IonLabel>{api.tr('where_create')}</IonLabel>
    <IonChip slot="end" color={create ? 'light': 'primary'} className="p-2 m-2">
      <IonIcon icon={mapOutline} />
    </IonChip>
    <IonIcon icon={search} slot="end" size="small" className="mr-2" color="dark"/>
  </IonItem> : null }
  { walk.hasCoordinates && create ? <IonItem color="danger">
    <IonNote slot="end" color="light">{api.tr('placeMapPin')}</IonNote>
  </IonItem> : null }
  { walk.hasCoordinates ? 
  <IonItem lines="full">
    <IonIcon icon={location} slot="start" size="small" className="mr-2" color="darkblue"/>
    <IonLabel>{api.tr('part5_meetingspot')}</IonLabel>
    <IonInput 
      onIonChange={(e) => {
        setWalk({...walk, place_name: e.detail.value})
      }}
      className="text_right" value={walk.place_name} placeholder="Enter place" />
    <IonIcon icon={pencil} slot="end" size="small" className="mr-2" color="dark"/>
  </IonItem> : null }
  { !description ? 
  <IonItem lines="none" className="text_center fullWidth" onClick={() => setDescription(true)}>
    <IonText color="primary">{api.tr('AddWalk_description')}</IonText>
  </IonItem>
  : 
  <IonCard className=" p-2 m-2 flex flex-col">
    <IonLabel className="mr-2">{api.tr('description')}</IonLabel>
    <IonItem lines="full">
      <IonTextarea autoGrow 
        value={walk.description} 
        placeholder={api.tr('enter_description')} 
        onIonChange={e => {
          setWalk({...walk, description: e.detail.value!})
        }}/>
    </IonItem>
  </IonCard>
  }
</IonCard>
<IonList onClick={() => !hasPro ? setProModal(true) : null}>
  <IonListHeader className="p-2 color_blue"><h2>{api.tr('Pro_features')}</h2></IonListHeader>
  <IonItem 
    lines='full' 
    onClick={() => {
      if(hasPro){
        openSlide(7)
      } else {
        setProModal(true)
      }
    }}>
    <IonIcon icon={repeat} slot="start" size="small" className="mr-2" color={hasPro ? 'darkblue' : 'medium'}/>
    {proButton()}
    <IonLabel>{api.tr('Walking_repeat')}</IonLabel>
    <IonInput 
      disabled={hasPro ? false : true}
      className="text_right" 
      value={repetitionValue()} 
      placeholder={walk.recurring && walk.recurring.length > 0 ? 'Promenaden repeteras': api.tr('Walking_DontRepeat')}/>
    <IonIcon icon={caretDown} slot="end" size="small" className="mr-2" color={hasPro ? "dark" : 'medium'}/>
  </IonItem>
  <IonItem onClick={() => {
      if(hasPro){
        openSlide(5)
      } else {
        setProModal(true)
      }
    }}>
    <IonIcon color={hasPro ? 'darkblue' : 'medium'} icon={person} slot="start" size="small" className="mr-2"/>
    {proButton()}
    <IonLabel color={hasPro ? "dark" : 'medium'}>{api.tr('Walk_invite')}</IonLabel>
    {walk.invited_persons && walk.invited_persons.length > 0 ?
    <IonAvatar>
      <img src={'/assets/images/profile.png'} alt=""/>
    </IonAvatar> : null}
    <IonText color={hasPro ? "dark" : 'medium'} className="mr-2">{walk.invited_persons && walk.invited_persons.length > 0 ? api.tr('Invite_button') : api.tr('walk_choose_person')}</IonText>
    <IonIcon icon={caretDown} slot="end" size="small" className="mr-2" color={hasPro ? "dark" : 'medium'}/>
  </IonItem>
  <IonItem lines="full"
   onClick={() => {
     if(!hasPro) {
      setProModal(true)
     }
   }}>
    <IonIcon color={hasPro ? 'darkblue' : 'medium'} icon={people} slot="start" size="small" className="mr-2"/>
    {proButton()}
    <IonLabel color={walk.invited_persons && walk.invited_persons.length > 0 ? 'medium' : 'none'}>{api.tr('Walk_available_spots')}</IonLabel>
    <IonSelect 
      onIonChange={(e) => {
        setWalk({...walk, max_bookings: e.target.value})
      }}
      disabled={(walk.invited_persons && walk.invited_persons.length > 0)|| !hasPro} 
      placeholder={walk.max_bookings ? walk.max_bookings.toString() : '1'} 
      okText={api.tr('setNumberOf')}
      cancelText={api.tr('cancel')} 
      slot="end">
      {[1,2,3,4,5,6,7,8].map((number: number, index: any) => <IonSelectOption key={'ionselect'+index} value={number}>{number}</IonSelectOption>)}
    </IonSelect>
  </IonItem>
  <IonItem 
    lines="full"
    onClick={() => {
      if(!hasPro) {
       setProModal(true)
      }
    }}>
    <IonIcon color={walk.profile_only || !hasPro ? 'medium' : "darkblue"} icon={lockClosed} slot="start" size="small" className="mr-2"/>
    {proButton()}
    <IonLabel color={(walk.invited_persons && walk.invited_persons.length > 0) || !hasPro ? 'medium' : 'none'}>{api.tr('Walk_privateWalk')}</IonLabel>
    <IonToggle 
      mode="ios" 
      disabled={((walk.profile_only || walk.invited_persons) && walk.invited_persons.length > 0) || !hasPro } 
      slot="end" 
      checked={walk.invite_only} 
      onIonChange={(e) => {
        if(walk.invite_only !== e.detail.checked) {
          setWalk({...walk, invite_only: !walk.invite_only})
        }
      }}/>
  </IonItem>
  <IonItem lines="full"
    onClick={() => {
      if(!hasPro) {
        setProModal(true)
      }
    }}>
    <IonIcon color={walk.invite_only || !hasPro ? 'medium' : 'darkblue'} icon={eye} slot="start" size="small" className="mr-2"/>
    {proButton()}
    <IonLabel color={(walk.invited_persons && walk.invited_persons.length > 0) || !hasPro ? 'medium' : 'none'}>{api.tr('Walk_onlyIn_profile')}</IonLabel>
    <IonToggle mode="ios" disabled={((walk.invite_only || walk.invited_persons) && walk.invited_persons.length > 0) || !hasPro } slot="end" checked={walk.profile_only} 
      onIonChange={(e) => {
        if(walk.profile_only !== e.detail.checked) {
          setWalk({...walk, profile_only: !walk.profile_only})
        }
      }}/>
  </IonItem>
</IonList>
{ nextSlideButton() }
</IonGrid>
<SafetyPadding/>
</IonContent>

const onSlideChange = () => {
  const index = swiperInstance.activeIndex

  setActiveSlide(activeFlow[index])
  setPageInfo({...pageInfo, header: pageInfo.header })
}

  const openSlide = (slide: number) => {
    setActiveFlow([slide])
    setOpenSlides(true)
  }

  const SlideTwo = () => <GoogleMapNew
    closeModal={slideNext}
    handlePlaceInput={handlePlaceInput}
    handleTextInput={handleTextInput}
    handleLatLng={handleLatLng}
    setCreate={setCreate}
    create={create}
    error={error}
    setError={setError}
    saveMap={saveMap} 
    lat={walk.lat} 
    lng={walk.lng} 
    zoom={walk.zoom}
    placeName={walk.place_name} 
    fixedMarker={false} 
    height={100}
    cancelCreate={cancelCreate}/>

  const SlideThree = () => <CreateCalendarPicker 
    cancelCreate={cancelCreate}
    slideNext={slideNext}
    slidePrevious={slidePrevious}
    error={error}
    setError={setError}
    length_minutes={walk.length_minutes}
    start={walk.start}
    handleStart={handleStart}
    handleLength={handleLength}
    activeSlide={activeSlide === 2} />

  const handleWalkType = (e: any) => {
    setWalk({
      ...walk,
      ...e
    })
  }

  const SlideFour = (id: number) => <CreateWalkType 
    checkIfMapSlide={checkIfMapSlide}
    cancelCreate={cancelCreate}
    slideNext={slideNext}
    handleWalkType={handleWalkType}
    hasTalk={walk.hasTalk}
    hasCoordinates={walk.hasCoordinates}
    id={id}/>

  const handleNetwork = (value: number | null) => {
    setWalk({
      ...walk, 
      teamId: value
    })
  }

  const SlideFive = () => <CreateNetworkPicker slideNext={slideNext} cancelCreate={cancelCreate} teamId={walk.teamId} handleNetwork={handleNetwork}/>

  const SlideSix = () => <CreatePersonInvite 
    slideNext={slideNext} 
    cancelCreate={cancelCreate}  
    handleInvite={handleInvite} 
    handleMultipleInvite={handleMultipleInvite}
    invited_persons={walk.invited_persons} />

  const handleCategory = (value: string) => {
    setWalk({...walk, category: value})
  }

  const SlideSeven = () => <CreateCategory handleCategory={handleCategory} category={walk.category}/>

  const handleRepeat = (repeatArr: Array<any>) => {
    setWalk(walk => ({
      ...walk, 
      start: repeatArr[0].start,
      startFormat: repeatArr[0].start,
      recurring: repeatArr
    }))
  }

  const SlideEight = () => <CreateRepeat 
    slideNext={slideNext} 
    cancelCreate={cancelCreate} 
    handleStart={handleStart} 
    start={walk.start} 
    recurring={walk.recurring} 
    handleRepeat={handleRepeat} 
    repeatOption={repeatOption} 
    setRepeatOption={setRepeatOption}
    invited_persons={walk.invited_persons}
    />

  const SlideNine = () => <CreateGroup walk={walk} setWalk={setWalk} cancelCreate={cancelCreate} slideNext={slideNext}/>

  const SlideTen = () => <CreateDay cancelCreate={cancelCreate}
  slideNext={slideNext}
  slidePrevious={slidePrevious}
  error={error}
  setError={setError}
  length_minutes={walk.length_minutes}
  start={walk.start}
  handleStart={handleStart}/>

  const SlideEleven = () => <CreateTime 
  cancelCreate={cancelCreate}
  slideNext={slideNext}
  slidePrevious={slidePrevious}
  error={error}
  setError={setError}
  length_minutes={walk.length_minutes}
  start={walk.start}
  handleLength={handleLength}
  handleStart={handleStart}/>

  // these are slide definitions, add slide and component here.
  const data = [
    { id: 0,
      title: 'Preview',
      subtitle: 'ett - sub',
      input: [{name: 'ett', placeholder: 'test', text: 'testar'}, {name: 'ett.ett', placeholder: 'try', text: 'testa igen'}],
      component: SlideOne()
    },
    { id: 1,
      title: 'Map',
      subtitle: 'två - sub',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideTwo()
    },
    { id: 2,
      title: 'Time',
      subtitle: 'två - sub',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideThree()
    },
    { id: 3,
      title: 'Type',
      subtitle: 'två - sub',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideFour(3)
    },
    { id: 4,
      title: 'Network',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideFive()
    },
    { id: 5,
      title: 'Person',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideSix()
    },
    { id: 6,
      title: 'Category',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideSeven()
    },
    { id: 7,
      title: 'Repeat',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideEight()
    }, 
    { id: 8,
      title: 'Group',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideNine()
    },
    { id: 9,
      title: 'Day',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideTen()
    },
    { id: 10,
      title: 'Day',
      subtitle: 'five',
      input: [{name: 'två', placeholder: 'test', text: 'testar'}],
      component: SlideEleven()
    },
  ]

  const Slides = () => {
    let activeSlides: any[] = []

    for(let i = 0; i < activeFlow.length; i++) {
      data.find(slide => {
        if(slide.id === activeFlow[i]) {
          activeSlides.push(slide)
        }
      })
    }

    return activeSlides.map((slide, index) => {
        return <SwiperSlide key={`slides_${index}`} id={slide.id}> 
        <IonHeader>
          <IonToolbar>
            { swiperInstance.activeIndex === 0 ? null : 
            <IonButtons slot="start">
              <IonButton onClick={() => {
                enableSlidePrevious()
                swiperInstance.slidePrev()
                }}>
                <IonIcon icon={arrowBack}/>
              </IonButton>
            </IonButtons> }
            <IonTitle>
            <h2>
              { pageInfo.header } - 
              {activeSlides.length > 1 ? 
              <IonChip color="darkblue" className="p-2 m-2">
                {`${ index + 1 } /
                ${ activeSlides.length }`}
              </IonChip>: null}
            </h2>
            </IonTitle>
            <IonButtons slot="end">
              <IonButton 
                size="small"
                color="primary"
                fill="solid"
                onClick={() => {
                  if(swiperInstance.isEnd) {
                    if(slide.id === 0) {
                      saveWalk()
                    } else {
                      setActiveFlow(previousSlides)
                      setTimeout(() => {
                        swiperInstance.slideTo(previousSlides.indexOf(0))
                      }, 100);
                      errorCheck()
                    }
                  } else {
                    if(slide.id === 3){
                      if(walk.hasCoordinates) {
                        slideNext()
                      } else {
                        swiperInstance.slideTo(swiperInstance.activeIndex + 2)
                        errorCheck()
                      }
                    } else {
                      slideNext()
                    }
                  }
                }}>
                { swiperInstance.isEnd ? 
                    <>
                    { slide.id === 0 ?
                      <IonLabel>{pageInfo.button}</IonLabel>
                      : 
                      <IonIcon icon={closeCircle}/>
                      }
                    </>
                   : 
                    <IonIcon icon={arrowForward} />
                }
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        { slide.component }
      </SwiperSlide> 
    })
  }

  const disableSlideNext = () => {
    swiperInstance.allowSlideNext = false
  }

  const disableSlidePrev = () => {
    swiperInstance.allowSlidePrev = false
  }

  const enableSlideNext = () => {
    swiperInstance.allowSlideNext = true
    setError({...error, status: false})
  }

  const enableSlidePrevious = () => {
    swiperInstance.allowSlidePrev = true
    setError({...error, status: false})
  }

  const SwiperComponent = () => {
    return <Swiper 
      className="mySwiper"
      modules={[Navigation, Pagination, Scrollbar, IonicSlides]} 
      pagination={{ type: 'progressbar' }}
      slidesPerView={1}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
      onSlideChange={() => onSlideChange()}>
        { Slides() }
    </Swiper>
  }

  useEffect(() => {
    swiperInstance.allowTouchMove = false
  }, [SwiperComponent])

  const handleMultipleInviteMessage = (walks: Array<any>) => {
    walks.forEach((walk) => {
      if(walk.availableTo.length > 0) {
        walk.availableTo.forEach((person: any) => {
          const json =`{ "date": "${walk.start}", "accepted": null, "createdWalk": true, "walkID": ${walk.id}, "deletedWalk": false }`
          sendMessageWalk(1, person.id, api.tr('sent_an_invite'), json)
        })
      }
    })
  }

  const saveWalk = () => {
    if(errorCheck() === true) {
      api.post('/walk/save/' + walk.walkId, walk).then(res => {
        res.json().then(data => {
          console.log(data)
          if(data.status === 'ok') {
            if(walk.invited_persons.length > 0) {
              handleMultipleInviteMessage(data.walks)
            }
            // if(walk.invited_persons.length > 0) {
            //   const json =`{ "date": "${data.walk.start}", "accepted": null, "createdWalk": true, "walkID": ${data.id}, "deletedWalk": false }`
            //   sendMessageWalk(1, walk.invited_persons[0], api.tr('sent_an_invite'), json)
            // }
            const stateData = {id: data.id, walks: data.walks}
            setOpenSlides(false)
            goToPageWithState('/walk/success', stateData)
          }
        })
      }).catch( e => {
        dispatch(openAlert({
          message: api.tr('something_went_wrong'),
          header: api.tr('error_message')
        }))
      })  
    } else {
      setErrorAlert(true)
    }
  }

  const fetchWalk = (urlString: string) => {
    const paramWalkID = urlString.replace(/\D/g, "")
    api.get('walk/' + paramWalkID).then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          const walkFetch: WalkI = data.walk
          let invitedPerson = walkFetch.availableTo.length > 0 ? [walkFetch.availableTo[0].id] : []

          setWalk(walk => ({
            ...walk, 
            walkId: walkFetch.id,
            name: walkFetch.name,
            place_name: walkFetch.placeName,
            description: walkFetch.description,
            lat: walkFetch.lat,
            lng: walkFetch.lng,
            zoom: walkFetch.zoom,
            start: walkFetch.start,
            startFormat: walkFetch.startFormat,
            length_minutes: walkFetch.lengthMinutes,
            teamId: walkFetch.teamId,
            address: walkFetch.address,
            category: walkFetch.category,
            invited_persons: invitedPerson,
            invite_only: walkFetch.inviteOnly,
            profile_only: walkFetch.profileOnly,
            max_bookings: walkFetch.maxBookings,
            hasCoordinates: walkFetch.hasCoordinates,
            hasTalk: walkFetch.hasTalk,
            recurring: []
          }))
        }
      })
    })
  }

  const errorCheck = () => {
    let inputIsValid = true
    let titleError = true
    let startError = true
    let mapError = true
    let typeError = true

    if(walk.name.length < 2) {
      titleError = true
      inputIsValid = false
    } else {
      titleError = false
    }

    if(!walk.start || isInThePast(new Date(walk.start)) === true ) {
      if(walk.recurring.length > 0) {
        startError = false
      } else {
        inputIsValid = false
        startError = true
      }
    } else {
      startError = false
    }

    if((walk.hasCoordinates && create) || (walk.hasCoordinates && !walk.lat)) {
      inputIsValid = false
      mapError = true
    } else {
      mapError = false
    }

    if(!walk.hasTalk && !walk.hasCoordinates) {
      inputIsValid = false
      typeError = true
    } else {
      typeError = false
    }

    setError({
      ...error,
      status: inputIsValid,
      title: titleError,
      start: startError,
      map: mapError,
      type: typeError
    })

    return inputIsValid
  }

  const isInThePast = (date: Date) => {
    const today = new Date();
    return date < today;                        
  }

  const walkTypePicker = (title: string, subtitle: string, Pro: boolean, icon: string, key:any, slides?: Array<number>, data?: any) => {
    let pickIcon = walkIcon
    if(icon === 'repeat'){
      pickIcon = repeat
    } else if(icon === 'eyeOutline') {
      pickIcon = lockOpen
    } else if(icon === 'mic') {
      pickIcon = mic
    } else if(icon === 'walkIcon') {
      pickIcon = walkIcon
    } else if(icon === 'people') {
      pickIcon = people
    } else if(icon === 'person') {
      pickIcon = person
    } else if(icon === 'lockClosed') {
      pickIcon = lockClosed
    } else if(icon === 'eye') {
      pickIcon = eye
    } 

    return <IonCard 
      key={key} 
      class="m-2 p-2" 
      onClick={() => {
        if((!hasPro && !Pro) || hasPro) {
          firebaseProvider.trackEvent(title, undefined)
          //HÄR
          // goToPage('/walk/create')
          setOpenSlides(true)
          if(slides) {
            setActiveFlow(slides)
          }
          if(data) {
            setWalk({...walk, ...data})
          }
        } else if(!hasPro && Pro) {
          setProModal(true)
        }
      }}>
      <IonCardHeader>
        <IonRow>
          <IonCol size="1" className="flex justify-center items-center">
            <IonIcon icon={pickIcon} size="large" color={Pro ? hasPro ? 'darkblue' : 'medium' : 'primary'}/>
          </IonCol>
          <IonRow className="flex justify-start items-center">
            <IonCardTitle mode="md" color={Pro ? hasPro ? 'darkblue' : 'medium' : 'primary'}>
              <h2>{title}</h2>
            </IonCardTitle>
            { hasPro ? null : 
            <>
            { Pro ? <IonChip className="p-2 m-2" color="medium">
              <IonIcon icon={lockClosed}/>
                Pro
              </IonChip> : null }
            </>}
          </IonRow>
        </IonRow>
        <IonCardSubtitle mode="md" class="p-2" color={Pro ? hasPro ? 'dark' : 'medium' : 'dark'}>{subtitle}</IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>
        <IonRow className="flex justify-end items-center">
          <IonButton 
            color={Pro ? hasPro ? 'darkblue' : 'medium'  : 'primary'}
            onClick={() => {
              if((!hasPro && !Pro )|| hasPro) {
                //HÄR
                // goToPage('/walk/create')
                setOpenSlides(true)
                if(slides) {
                  setActiveFlow(slides)
                }
                if(data) {
                  setWalk({...walk, ...data})
                }
              } else if(!hasPro && Pro)  {
                setProModal(true)
              }
            }}>
            {api.tr('choose')}
            <IonIcon icon={arrowForward} className="ml-2"/>
          </IonButton>
        </IonRow>
      </IonCardContent>
    </IonCard>
  }

  return (
    <IonPage className="cheap_desktop createPage">
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            <h2 className="margin_center"> 
            { pageInfo.header } 
            </h2>
          </IonTitle>
          {isPlatform('desktop') ? 
          <IonButtons slot="end">
            <IonButton 
              color="darkblue"
              onClick={() => {
                goToPage('/walk/faq')
              }}>
                <IonIcon icon={informationCircle}/>
              FAQ
            </IonButton>
          </IonButtons> : null}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        { isPlatform('desktop') ? null : 
        <IonCard onClick={() => {
          goToPage('/walk/faq')
        }} color="" className="m-2 p-2">
          <IonCardHeader>
            <IonToolbar color="">
              <IonIcon size="large" icon={informationCircle} slot="start" color="darkblue" className="mr-2"/>
                <IonCardTitle mode="md" ><h2 className="color_blue">FAQ</h2></IonCardTitle>
                {/* <IonCardSubtitle color="medium">{api.tr('FAQ_banner_top')}</IonCardSubtitle> */}
              <IonIcon slot="end" icon={arrowForward} size="large"/>
            </IonToolbar>
          </IonCardHeader>
        </IonCard> }
        {isPlatform('desktop')? null : 
        <IonRow className="imageGradient--container m-4 p-2">
          <IonImg src={'/assets/images/StepPath.png'}>
          </IonImg>
          <div className="imageGradient--white"></div>
        </IonRow>
        }
        <IonList>
          <IonListHeader className="m-2">
            <h2 className="m-2 color_blue flex items-center">
              <IonChip color="darkblue" slot="start" className="circle_small flex justify-center items-center mr-2">1</IonChip>
                {api.tr('creatingwalkfp_choice')}
            </h2>
          </IonListHeader>
          { walkTypes.map((type: any, index: any) => walkTypePicker(type.title, type.subtitle, type.pro, type.icon, index, type.slides, type.data)) }
        </IonList>
        <SafetyPadding/>
      </IonContent>
     { openSlides && walk ? 
     
     <IonModal 
        class={isPlatform('desktop') ? 'modal_full p-2' : 'modal_full'} 
        isOpen={openSlides} 
        onDidDismiss={() => {
          setOpenSlides(false)
          setError({...error, status: false})
        }}>
        { SwiperComponent() }
      </IonModal> : null }
      <UpgradeAlert
        proModal={proModal}
        setProModal={setProModal}
        leaveModal={() => {
          setProModal(false)
          setOpenSlides(false)
          goToPage('/walk/getteams')
        }}/>
      <IonAlert
        isOpen={errorAlert}
        onDidDismiss={() => setErrorAlert(false)}
        header={api.tr('error_message')}
        subHeader={api.tr('Error_control_walk')}
        message=""
        buttons={[
          {
            text: api.tr('cancel'),
            role: 'cancel',
            handler: () => {
              setErrorAlert(false)
            },
          },
          {
            text: 'OK',
            role: 'confirm',
            handler: () => {
              setErrorAlert(false)
            },
          },
        ]}/>
      <IonAlert
        isOpen={closingAlert}
        onDidDismiss={() => setClosingAlert(false)}
        header={api.tr('cancel_errormessage_title')}
        subHeader={api.tr('cancel_errormessage_header')}
        message={api.tr('cancel_errormessage_text')}
        buttons={[
          {
            text: api.tr('cancel'),
            role: 'cancel',
            handler: () => {
              setClosingAlert(false)
            },
          },
          {
            text: 'OK',
            role: 'confirm',
            handler: () => {
              cancelingCreate()
              setErrorAlert(false)
            },
          },
        ]}/>
    </IonPage>
  )
}

export default CreatePage
